
export default function PaddedRightRow({children}) {
  return (
      <div className='d-flex justify-content-end gap-2'>
        {children}
      </div>
  )
}